import React, {Component} from 'react';
import PrivateRoute from '../../../Common/PrivateRoute';
import RefundOverview from './RefundOverview';
import RefundApplicationForm from './RefundApplicationForm';
import {PageContainer, PageTitle} from '../../../Common/PageComponents';

class Refund extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="결제취소/환불신청" data-qa="usagePageTitle">
          Home &gt; MY PC방&gt; PC방 관리 &gt; <strong> 결제취소/환불신청</strong>
        </PageTitle>
        <PrivateRoute exact path="/my-pc-bang/usage-status/refund" component={RefundOverview} />
        <PrivateRoute exact path="/my-pc-bang/usage-status/refund/application" component={RefundApplicationForm} />
      </PageContainer>
    );
  }
}

export default Refund;
